export enum StartCommunityOfPracticeType {
  Coaching = 'Coaching',
  ComprehensiveCommunicationSupportsAndStrategies = 'Comprehensive Communication Supports and Strategies',
  EarlyChildhood = 'Early Childhood',
  PeerToPeer = 'Peer to Peer',
  PfaSbt = 'PFA-SBT',
  SecondaryTransition = 'Secondary Transition',
  SexualHealth = 'Sexual Health'
}
